import { motion } from 'framer-motion';

const SYMBOL_EMOJI: Record<string, string> = {
  cherry: '🍒',
  lemon: '🍋',
  bell: '🔔',
  bar: '🍫',
  seven: '7️⃣',
};

function symbolGlyph(id: string): string {
  return SYMBOL_EMOJI[id] ?? '🎰';
}

export function ReelAnimation({
  reels,
  spinning,
}: {
  reels: string[];
  spinning: boolean;
}) {
  const cells = reels.length ? reels : ['seven', 'seven', 'seven'];
  return (
    <div className="flex justify-center gap-3">
      {cells.map((sym, i) => (
        <motion.div
          key={i}
          className="flex h-24 w-24 items-center justify-center rounded-xl border-2 border-gold bg-felt-dark text-5xl shadow-inner"
          animate={spinning ? { rotateX: [0, 360] } : { rotateX: 0 }}
          transition={
            spinning
              ? { repeat: Infinity, duration: 0.4, delay: i * 0.08 }
              : { duration: 0.3 }
          }
        >
          {spinning ? '🎰' : symbolGlyph(sym)}
        </motion.div>
      ))}
    </div>
  );
}
